import { IFilterElement } from "@saleor/components/Filter";
// import {
//   // SaleFilterKeys,
//   SaleListFilterOpts
// } from "@saleor/discounts/components/SaleListPage";
import { joinDateTime, maybe } from "@saleor/misc";
import {
  RegisterFilterKeys,
  RegisterFilterOpts
} from "@saleor/register/components/RegisterListPage/filters";
import {
  // DiscountStatusEnum,
  // DiscountValueTypeEnum,
  RecommendFilterInput
  // SaleFilterInput
} from "@saleor/types/globalTypes";

import {
  createFilterTabUtils,
  createFilterUtils,
  // dedupeFilter,
  getGteLteVariables,
  getMinMaxQueryParam
  // getMinMaxQueryParam,
  // getMultipleEnumValueQueryParam,
  // getSingleEnumValueQueryParam
} from "../../../utils/filters";
import {
  RegisterListUrlFilters,
  RegisterListUrlFiltersEnum,
  RegisterListUrlFiltersWithMultipleValues,
  RegisterListUrlQueryParams
} from "../../urls";

export const SALE_FILTERS_KEY = "saleFilters";

export function getFilterOpts(
  params: RegisterListUrlFilters
): RegisterFilterOpts {
  return {
    // saleType: {
    //   active: !!maybe(() => params.type),
    //   value: maybe(() => findValueInEnum(params.type, DiscountValueTypeEnum))
    // },
    created: {
      active: maybe(
        () =>
          [params.startedFrom, params.startedTo].some(
            field => field !== undefined
          ),
        false
      ),
      value: {
        max: maybe(() => params.startedTo, ""),
        min: maybe(() => params.startedFrom, "")
      }
    }
    // status: {
    //   active: !!maybe(() => params.status),
    //   value: maybe(
    //     () =>
    //       dedupeFilter(
    //         params.status.map(status =>
    //           findValueInEnum(status, DiscountStatusEnum)
    //         )
    //       ),
    //     []
    //   )
    // }
  };
}

export function getFilterVariables(
  params: RegisterListUrlFilters
): RecommendFilterInput {
  return {
    // saleType:
    //   params.type && findValueInEnum(params.type, DiscountValueTypeEnum),
    search: params.query,
    created: getGteLteVariables({
      gte: joinDateTime(params.startedFrom),
      lte: joinDateTime(params.startedTo)
    })
    // status:
    //   params.status &&
    //   params.status.map(status => findValueInEnum(status, DiscountStatusEnum))
  };
}

export function getFilterQueryParam(
  filter: IFilterElement<RegisterFilterKeys>
): RegisterListUrlFilters {
  const { name } = filter;

  switch (name) {
    // case RegisterFilterKeys.created:
    //   return getSingleEnumValueQueryParam(
    //     filter,
    //     RegisterListUrlFiltersEnum.startedFrom,
    //     RegisterListUrlFiltersEnum.startedTo,
    //     // DiscountValueTypeEnum
    //   );

    case RegisterFilterKeys.created:
      return getMinMaxQueryParam(
        filter,
        RegisterListUrlFiltersEnum.startedFrom,
        RegisterListUrlFiltersEnum.startedTo
      );

    // case SaleFilterKeys.started:
    //   return getMinMaxQueryParam(
    //     filter,
    //     RegisterListUrlFiltersEnum.startedFrom,
    //     RegisterListUrlFiltersEnum.startedTo
    //   );

    // case SaleFilterKeys.status:
    //   return getMultipleEnumValueQueryParam(
    //     filter,
    //     RegisterListUrlFiltersWithMultipleValues.status,
    //     DiscountStatusEnum
    //   );
  }
}

export const {
  deleteFilterTab,
  getFilterTabs,
  saveFilterTab
} = createFilterTabUtils<RegisterListUrlFilters>(SALE_FILTERS_KEY);

export const { areFiltersApplied, getActiveFilters } = createFilterUtils<
  RegisterListUrlQueryParams,
  RegisterListUrlFilters
>({
  ...RegisterListUrlFiltersEnum,
  ...RegisterListUrlFiltersWithMultipleValues
});
